module.exports = __webpack_public_path__ + "static/media/doreman.c4154485.jpg";